/* istanbul ignore file */
import { Loading } from '../../../mui-builder';
import React from 'react';
import { useFormContext } from 'framework/form';

const LoadingFormLayout = () => {
  const { isSubmitEnabled } = useFormContext();

  return !isSubmitEnabled ? <Loading /> : null;
};

export default LoadingFormLayout;
